<script lang="ts">
  import Form from 'Components/Common/Form/Form.svelte';
  import DollarInput from 'Components/Common/Form/DollarInput.svelte';

  import {deal} from 'Store/InvestorFlowStore';
  import {incentivePlans} from 'Store/deals/incentivePlan';

  import {moneyMask} from 'Utility/investorFlow/v2/amountSelection';
  import {integerMask} from 'Utility/formatters/mask';
  import {numberOfSecurities} from 'Utility/investorFlow/v2/amountSelection';

  export let maskedValue: string;
  export let customInvestmentAmount: number = $deal.minimum_investment;
  export let numSecurities: number;
  export let forceDecimals: boolean = true;
  export let hideUnitConverter: boolean = false;

  $: investmentAmount = parseFloat(maskedValue) * 100 || customInvestmentAmount;

  $: originalNumberOfSecurities = numberOfSecurities(
    investmentAmount,
    $incentivePlans?.full_price?.amount * 100
  );

  $: showOriginalPrice =
    $incentivePlans?.full_price?.amount_cents !==
    $incentivePlans?.final_price?.amount_cents;
</script>

<div class="amount-container">
  <Form>
    <DollarInput
      bind:maskedValue
      name="money-container"
      placeholder="Investment amount"
      newLayout={true}
      moneyMask={moneyMask(forceDecimals, $deal.currency_symbol)}
      on:input
    />
  </Form>
  {#if customInvestmentAmount && !hideUnitConverter}
    <p
      class="custom-investment-subtext"
      data-testid="custom-investment-subtext"
    >
      <span data-testid="number-of-securities" class="num-securities">
        <span>= </span>
        {#if showOriginalPrice}
          <s> {integerMask(originalNumberOfSecurities)}</s>
        {/if}
        <span> {integerMask(numSecurities)} {$deal.security_type}</span>
      </span>
    </p>
  {/if}
</div>

<style lang="postcss">
  .custom-investment-subtext {
    white-space: normal;
    font-size: 1rem;
    margin-bottom: 0;
    margin-top: 0.5rem;
    text-align: center;
  }

  .num-securities {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: center;
    color: var(--dm-text-secondary-color, var(--palettes-neutral-575, #667085));
  }

  .amount-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
